import script from "./GererEspaces.vue?vue&type=script&setup=true&lang=js"
export * from "./GererEspaces.vue?vue&type=script&setup=true&lang=js"

import "./GererEspaces.vue?vue&type=style&index=0&id=5c10af5f&lang=css"

const __exports__ = script;

export default __exports__